// eslint-disable-next-line
import React, { Component } from "react";
import ReactDOM from "react-dom";

let actionsRoot = document.getElementById("user-menu-actions-root");

class UserMenuActionsPortal extends Component {
  constructor(props) {
    super(props);

    this.el = document.createElement("div");
  }

  componentDidMount() {
    actionsRoot = document.getElementById("user-menu-actions-root");
    actionsRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    actionsRoot = document.getElementById("user-menu-actions-root");
    actionsRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default UserMenuActionsPortal;
